var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vx-card", { staticClass: "mb-4" }, [
        _c(
          "div",
          { staticClass: "flex justify-between items-start flex-wrap gap-2" },
          [
            _c("div", [
              _c("h4", { staticClass: "mb-1" }, [
                _vm._v(_vm._s(_vm.$t("withdrawal.title"))),
              ]),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("withdrawal.hint"))),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c("b-form-select", {
                  staticStyle: { width: "220px" },
                  attrs: { options: _vm.statusFilters, size: "sm" },
                  on: { change: _vm.load },
                  model: {
                    value: _vm.filterStatus,
                    callback: function ($$v) {
                      _vm.filterStatus = $$v
                    },
                    expression: "filterStatus",
                  },
                }),
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "outline-primary" },
                    on: { click: _vm.load },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-25",
                      attrs: { icon: "RefreshCwIcon" },
                    }),
                    _vm._v(_vm._s(_vm.$t("action.reload")) + " "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c("vx-card", [
        _vm.isLoading
          ? _c("div", { staticClass: "text-center py-4 text-muted" }, [
              _vm._v(_vm._s(_vm.$t("common.loading"))),
            ])
          : !_vm.rows.length
          ? _c(
              "div",
              { staticClass: "text-center py-4" },
              [
                _c("feather-icon", {
                  staticClass: "h-8 w-8 text-success mb-1",
                  attrs: { icon: "CheckCircleIcon" },
                }),
                _c("p", { staticClass: "text-muted mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("withdrawal.empty"))),
                ]),
              ],
              1
            )
          : _c("table", { staticClass: "w-full admin-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("ID")]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("withdrawal.influencer")))]),
                  _c("th", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.$t("withdrawal.amount"))),
                  ]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("withdrawal.pix_key")))]),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("withdrawal.scheduled_for"))),
                  ]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("status")))]),
                  _c("th"),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (w) {
                  return _c("tr", { key: w.id }, [
                    _c("td", [_vm._v(_vm._s(w.id))]),
                    _c("td", [
                      _vm._v(
                        " " + _vm._s(_vm._.get(w, "influencer.name")) + " "
                      ),
                      _c("small", { staticClass: "text-muted d-block" }, [
                        _vm._v(
                          _vm._s(_vm.$t("withdrawal.requested_at")) +
                            ": " +
                            _vm._s(_vm.formatDate(w.requested_at))
                        ),
                      ]),
                    ]),
                    _c("td", { staticClass: "text-right" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.money(w.amount_cents)))]),
                      w.tax_withheld_cents
                        ? _c("small", { staticClass: "text-muted d-block" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("withdrawal.net")) +
                                ": " +
                                _vm._s(_vm.money(w.net_cents)) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", [
                      _c("code", [_vm._v(_vm._s(w.pix_key))]),
                      _c("small", { staticClass: "text-muted d-block" }, [
                        _vm._v(_vm._s(_vm.pixTypeLabel(w.pix_key_type))),
                      ]),
                    ]),
                    _c("td", [
                      w.scheduled_for
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.formatDate(w.scheduled_for))),
                          ])
                        : _c("span", { staticClass: "text-muted" }, [
                            _vm._v("—"),
                          ]),
                    ]),
                    _c(
                      "td",
                      [
                        _c(
                          "vs-chip",
                          {
                            attrs: {
                              transparent: "",
                              color: _vm.statusColor(w.status),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("withdrawal.status_." + w.status)
                                ) +
                                " "
                            ),
                          ]
                        ),
                        w.external_reference
                          ? _c("small", { staticClass: "text-muted d-block" }, [
                              _vm._v("E2E " + _vm._s(w.external_reference)),
                            ])
                          : _vm._e(),
                        w.rejection_reason || w.failure_reason
                          ? _c(
                              "small",
                              { staticClass: "text-danger d-block" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      w.rejection_reason || w.failure_reason
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "td",
                      { staticClass: "text-right actions" },
                      [
                        w.status === "SO"
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "withdrawals.approve",
                                    expression: "'withdrawals.approve'",
                                  },
                                ],
                                attrs: { size: "sm", variant: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.act(w, "approve")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("withdrawal.approve")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        ["SO", "AP"].includes(w.status)
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "withdrawals.schedule",
                                    expression: "'withdrawals.schedule'",
                                  },
                                ],
                                attrs: {
                                  size: "sm",
                                  variant: "outline-primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openSchedule(w)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("withdrawal.schedule")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        ["AP", "AG", "PR"].includes(w.status)
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "withdrawals.pay",
                                    expression: "'withdrawals.pay'",
                                  },
                                ],
                                attrs: { size: "sm", variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openPay(w)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("withdrawal.pay")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        ["SO", "AP", "AG"].includes(w.status)
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "withdrawals.approve",
                                    expression: "'withdrawals.approve'",
                                  },
                                ],
                                attrs: {
                                  size: "sm",
                                  variant: "outline-danger",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.act(w, "reject")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("withdrawal.reject")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        ["AP", "AG", "PR"].includes(w.status)
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "withdrawals.pay",
                                    expression: "'withdrawals.pay'",
                                  },
                                ],
                                attrs: {
                                  size: "sm",
                                  variant: "outline-warning",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.act(w, "fail")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("withdrawal.fail")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.$t("withdrawal.schedule"),
            "ok-title": _vm.$t("save"),
            "cancel-title": _vm.$t("action.cancel"),
          },
          on: { ok: _vm.confirmSchedule },
          model: {
            value: _vm.scheduleModal,
            callback: function ($$v) {
              _vm.scheduleModal = $$v
            },
            expression: "scheduleModal",
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: _vm.$t("withdrawal.scheduled_for") } },
            [
              _c("b-form-input", {
                attrs: { type: "date" },
                model: {
                  value: _vm.scheduleDate,
                  callback: function ($$v) {
                    _vm.scheduleDate = $$v
                  },
                  expression: "scheduleDate",
                },
              }),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("withdrawal.schedule_hint"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.$t("withdrawal.pay"),
            "ok-title": _vm.$t("withdrawal.confirm_payment"),
            "cancel-title": _vm.$t("action.cancel"),
            "ok-variant": "primary",
          },
          on: { ok: _vm.confirmPay },
          model: {
            value: _vm.payModal,
            callback: function ($$v) {
              _vm.payModal = $$v
            },
            expression: "payModal",
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: _vm.$t("withdrawal.e2e") } },
            [
              _c("b-form-input", {
                attrs: { type: "text", placeholder: "E2E..." },
                model: {
                  value: _vm.payReference,
                  callback: function ($$v) {
                    _vm.payReference = $$v
                  },
                  expression: "payReference",
                },
              }),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("withdrawal.e2e_hint"))),
              ]),
            ],
            1
          ),
          _c(
            "b-form-group",
            { attrs: { label: _vm.$t("withdrawal.tax_withheld") } },
            [
              _c(
                "b-input-group",
                { attrs: { prepend: "R$" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "number", step: "0.01", min: "0" },
                    model: {
                      value: _vm.payTax,
                      callback: function ($$v) {
                        _vm.payTax = $$v
                      },
                      expression: "payTax",
                    },
                  }),
                ],
                1
              ),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("withdrawal.tax_hint"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }